import { render, staticRenderFns } from "./EditorVideoBlock.vue?vue&type=template&id=2335ffa7&scoped=true"
import script from "./EditorVideoBlock.vue?vue&type=script&lang=js"
export * from "./EditorVideoBlock.vue?vue&type=script&lang=js"
import style0 from "./EditorVideoBlock.vue?vue&type=style&index=0&id=2335ffa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2335ffa7",
  null
  
)

export default component.exports